export const getRoute = (route: string, baseRoute?: string) => {
    baseRoute = baseRoute || '/leadform';
    return `${baseRoute}${route}`;
};

export const getAllRoutes = () => {
    return {
        root: '/summaryLeadForm',
        leadForm: '/leadForm'
    };
};
